// ===========================
// UTILITY FUNCTIONS
// ===========================
import { attributeTypeLabel } from './sql-options.js';

export function generateId(prefix = 'id') {
    const randomPart = globalThis.crypto?.randomUUID
        ? globalThis.crypto.randomUUID().replaceAll('-', '').slice(0, 12)
        : Math.random().toString(36).slice(2, 14);
    return `${prefix}_${Date.now().toString(36)}_${randomPart}`;
}

export function formatAttribute(attr) {
    let parts = [];

    // UQ denotes uniqueness; foreign keys come from the associations.
    if (attr.isUQ && !attr.isPK) {
        parts.push({ text: '[UQ] ', style: 'normal' });
        parts.push({ text: attr.name, style: 'normal' });
    }
    // Pour les clés primaires
    else if (attr.isPK) {
        parts.push({ text: attr.name, style: 'pk' });
    }
    // Attributs normaux
    else {
        parts.push({ text: attr.name, style: 'normal' });
    }

    // Type entre parenthèses
    if (attr.type) {
        parts.push({ text: ` (${attributeTypeLabel(attr)})`, style: 'type' });
    }

    // NOT NULL seulement pour les attributs non-PK
    if (!attr.isNull && !attr.isPK) {
        parts.push({ text: ' · NN', style: 'constraint' });
    }

    return parts;
}

// Version simple pour les associations (qui n'ont pas besoin de formatage spécial)
export function formatAttributeSimple(attr) {
    let text = attr.name;
    if (attr.type) text += ` (${attributeTypeLabel(attr)})`;
    return text;
}

export function calculateDistance(p1, p2) {
    const dx = p2.x - p1.x;
    const dy = p2.y - p1.y;
    return Math.sqrt(dx * dx + dy * dy);
}

export function calculateAngle(p1, p2) {
    return Math.atan2(p2.y - p1.y, p2.x - p1.x);
}

export function getPerpendicularOffset(angle, distance) {
    return {
        x: -Math.sin(angle) * distance,
        y: Math.cos(angle) * distance
    };
}

export function snapToGrid(pos, gridSize, enabled) {
    if (!enabled) return pos;
    return {
        x: Math.round(pos.x / gridSize) * gridSize,
        y: Math.round(pos.y / gridSize) * gridSize
    };
}
